import React from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import {
  avatar01,
  blog6,
} from "../../components/imagepath";
import { hooks } from "../../studentportal-sdk";
import CourseSidebar from "../../components/SideBar/CourseSidebar";
import { Skeleton } from "antd";
import SideBar from "../../components/SideBar/AdminSideBar";

const EnrolledAssessment = (props) => {
  const {
    assessmentService: {
      store: { assessmentDocs, loading},
      action: { storeAssessmentAction, deleteCourseById, getAssessmentResult},
    },
  } = props;

  const role = localStorage.getItem("role");
  const assessmentResult = localStorage.getItem('assessmentResult');
  
/* eslint-disable */
  return (
      <>
        <div className="main-wrapper">
          {/* Header */}
          <Header />
          {/* Sidebar */}
          {role === "admin" && <SideBar />
}
          {role === "user" && <CourseSidebar />}
          {/* Page Wrapper */}
          <div className="page-wrapper">
            <div className="content container-fluid">
              {/* Blog List */}
              <div className="row">
                <div className="col-md-9">
                  <ul className="list-links mb-4">
                    <li className="active">
                      <Link to="/assessments">Active Assessments</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="row">
                {/* Blog Post */}
                {!loading.active && !assessmentDocs && (
                  <p>Error Fetching Assessments</p>
                )}
                {loading.active ? (
                  <Skeleton active paragraph={{ rows: 10 }} />
                ) : (
                  <>
                    {assessmentDocs &&
                      assessmentDocs.map(({ id, title, description }) => (
                        <div
                          className="col-md-6 col-xl-4 col-sm-12 d-flex"
                          key={id}
                        >
                          <div className="blog grid-blog flex-fill">
                            <div className="blog-image">
                              <Link
                                to={"#"}
                                onClick={() =>
                                  storeAssessmentAction({ id, action: "view" })
                                }
                              >
                                <img
                                  className="img-fluid"
                                  src={blog6}
                                  alt="Post Image"
                                />
                              </Link>
                            </div>
                            <div className="blog-content">
                              <ul className="entry-meta meta-item">
                                <li>
                                  <div className="post-author">
                                    <Link to="/profile">
                                      <img src={avatar01} alt="Post Author" />
                                      <span>
                                        <span className="post-title">
                                          {title}
                                        </span>
                                      </span>
                                    </Link>
                                  </div>
                                </li>
                              </ul>
                              {/* <h3 className="blog-title">
                            <Link to="/coursedetails">{description}</Link>
                          </h3> */}
                              <p>{description}</p>
                            </div>
                            <div className="row">
                              <div className="edit-options">
                                {role === "admin" &&<div className="edit-delete-btn fetrash">
                                  
                                    <Link
                                      to={`#`}
                                      className="text-success"
                                      onClick={() =>
                                        storeAssessmentAction({
                                          id,
                                          action: "edit",
                                        })
                                      }
                                    >
                                      Edit
                                    </Link>
                                  <Link
                                    to="#"
                                    className="text-danger"
                                    data-bs-toggle="modal"
                                    data-bs-target="#deleteModal"
                                    onClick={() =>
                                      storeAssessmentAction({
                                        id,
                                        action: "delete",
                                      })
                                    }
                                  >
                                    Delete
                                  </Link>

                                  <Link
                                    to="#"
                                    className="text-info"
                                    data-bs-toggle="modal"
                                    data-bs-target="#resultModal"
                                    onClick={() =>
                                      getAssessmentResult(id)
                                    }
                                  >
                                   View Assessment Result
                                  </Link>
                                </div>}
                                {/* <div className="edit-delete-btn fetrash">
                                <Link
                                      to={`#`}
                                      className="text-success"
                                      onClick={() =>
                                        enrollForAssessment({
                                          assessmentId: id,
                                          // userId
                                        })
                                      }
                                    >
                                      Enroll
                                    </Link>
                                </div> */}
                                  
                                  
                                {/* <div className="text-end inactive-style">
                              <Link
                                to="#"
                                className="text-danger"
                                data-bs-toggle="modal"
                                data-bs-target="#deleteNotConfirmModal"
                              >
                                <i className="feather-eye-off me-1">
                                  <FeatherIcon icon="eye-off" />
                                  Inactive
                                </i>
                              </Link>
                            </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </>
                )}

              </div>
              {/* Pagination */}
              <div className="row ">
                <div className="col-md-12">
                  <div className="pagination-tab  d-flex justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item disabled">
                        <Link className="page-link" to="/course" tabIndex={-1}>
                          <i className="feather-chevron-left mr-2" />
                          Previous
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link" to="/course">
                          1
                        </Link>
                      </li>
                      <li className="page-item active">
                        <Link className="page-link" to="#">
                          2 <span className="sr-only">(current)</span>
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link" to="/course">
                          3
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link" to="/course">
                          4
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link" to="/course">
                          Next
                          <i className="feather-chevron-right ml-2" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* /Pagination */}
              {/* Modal */}
              <div
                className="modal fade contentmodal"
                id="deleteModal"
                tabIndex={-1}
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content doctor-profile">
                    <div className="modal-header pb-0 border-bottom-0  justify-content-end">
                      <button
                        type="button"
                        className="close-btn"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        <i className="feather-x-circle" />
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="delete-wrap text-center">
                        <div className="del-icon">
                          <i className="feather-x-circle" />
                        </div>
                        <h2>Sure you want to delete</h2>
                        <div className="submit-section">
                          <button
                            className="btn btn-success me-2"
                            onClick={() => deleteCourseById()}
                          >
                            Yes
                          </button>
                          <Link
                            to="#"
                            className="btn btn-danger"
                            data-bs-dismiss="modal"
                          >
                            No
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade contentmodal"
                id="resultModal"
                tabIndex={-1}
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content doctor-profile">
                    <div className="modal-header pb-0 border-bottom-0  justify-content-end">
                      <button
                        type="button"
                        className="close-btn"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        <i className="feather-x-circle" />
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="delete-wrap text-center">
                        <div className="del-icon">
                          <i className="feather-x-circle" />
                        </div>
                        <h2>Your Assessment Score: {assessmentResult}</h2>
                        <div className="submit-section">
                          <button
                            className="btn btn-success me-2"
                             data-bs-dismiss="modal"
                            // onClick={() => deleteCourseById()}
                          >
                            OK
                          </button>
                          {/* <Link
                            to="#"
                            className="btn btn-danger"
                            data-bs-dismiss="modal"
                          >
                            No
                          </Link> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Modal */}
            </div>
          </div>
          {/* /Page Wrapper */}
        </div>
        {/* /Main Wrapper */}
        {/* jQuery */}
        {/* Bootstrap Core JS */}
        {/* Feather Icon JS */}
        {/* Slimscroll JS */}
        {/* Select JS*/}
        {/* Feathericon js */}
        {/* Custom JS */}
      </>
  );
};

export default (props) => <EnrolledAssessment {...hooks.assessment(props)} />;
